import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Cabeçalho dos painéis do projeto (Explorador, Buscar, Git, Executar, Extensões): a mesma altura
 * das faixas de abas (40 px), título em caixa normal e as ações à direita.
 */
export function PanelHeader({
  title,
  actions,
  className,
}: {
  title: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex h-10 shrink-0 items-center justify-between gap-2 pl-4 pr-2", className)}>
      <h2 className="truncate text-[13px] font-semibold tracking-[-0.005em] text-fg">{title}</h2>
      {actions ? <div className="flex shrink-0 items-center gap-0.5">{actions}</div> : null}
    </div>
  );
}

/** Rótulo de seção dentro de um painel ("Comando", "Agora", "Nesta sessão"). */
export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn("text-[12px] font-medium text-fg-subtle", className)}>{children}</p>;
}
